<template>
  <div class="p-mt-2" :style="{
      width: '100%',
    }">
    <p-vue-progress-spinner
      strokeWidth="3"
      class="progress"
      v-if="isShowLoading && !newImage"
    />
    <img
      v-if="isShowLoading && newImage"
      :src="newImage"
      @click="showImg"
      :style="{
        width: imgWidth,
      }"
    />
    <img
      @click="showImg"
      :src="imgSrc"
      v-if="!isShowLoading"
      :style="{
        width: imgWidth,
      }"
    />
  </div>
</template>

<script>
import PVueProgressSpinner from "primevue/progressspinner";
import { API_HOST } from "@/services/APointAPI";
import { mapState } from "vuex";
export default {
  components: {
    PVueProgressSpinner,
  },
  props: {
    img: String,
    imgWidth: {
      type: String,
      default: "100%",
    },
    newImage: String,
  },
  emits: ["showImg"],
  data() {
    return {
      isShowLoading: true,
    };
  },
  mounted() {
    const I = new Image();
    I.onload = () => {
      this.isShowLoading = false;
    };
    I.onerror = (e) => {
      console.error("I.onerror", e);
      this.isShowLoading = false;
    };
    I.src = this.imgSrc;
  },
  methods: {
    showImg() {
      this.$emit("showImg", this.img);
    },
  },
  computed: {
    imgSrc() {
      if (this.img.startsWith("https://imagedelivery.net/")) return this.img;
      return (
        API_HOST +
        "/files/getImg?src=" +
        this.img +
        "&sessionToken=" +
        this.sessionToken
      );
    },
    ...mapState({
      sessionToken: (state) => state.api.sessionToken,
    }),
  },
};
</script>

<style scoped>
.root {
  display: flex;
  flex-wrap: wrap;

  margin: 0;
  padding: 0;

  list-style: none;
  color: var(--color-success-active);
}

.root li:not(:last-child):after {
  content: ", ";

  margin-left: 2px;
}

.root li a {
  color: inherit;
}
</style>
